import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowWall2Right: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"arrow-wall-2-right, align right"} maskId="square-filled-radius-0-stroke-1-IconArrowWall2Right"><path fillRule="evenodd" clipRule="evenodd" d="M21 4V20H20V12.2071L14.75 17.4571L14.0429 16.75L18.2929 12.5H3V11.5H18.2929L14.0429 7.25L14.75 6.54289L20 11.7929V4H21Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconArrowWall2Right;
